module.exports = __webpack_public_path__ + "img/1.047a7e03.jpg";